import MarkdownEditor from "../../../components/Markdown/MarkdownEditor";
import "./Post.css";

function PostCommentComposer({
  newComment,
  setNewComment,
  onSubmit,
  isSubmitting,
  error,
}) {
  return (
    <>
      <div className="PostCommentInput">
        <MarkdownEditor
          value={newComment}
          onChange={setNewComment}
          rows={3}
          disabled={isSubmitting}
          ariaLabel="Comment"
          placeholder=""
        />
        <button
          className="PostCommentSubmit"
          onClick={onSubmit}
          disabled={!newComment.trim() || isSubmitting}
        >
          {isSubmitting ? "Posting..." : "Comment"}
        </button>
      </div>
      <p className="PostCommentHint">
        Comments are posted anonymously as "Admin".
      </p>
      {error && <p className="PostCommentInputError">{error}</p>}
    </>
  );
}

export default PostCommentComposer;
